export const DEFAULT_FONTS = [
  {
    family: 'Open Sans',
    variants: [
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
    ],
    subsets: [
      'cyrillic',
      'cyrillic-ext',
      'greek',
      'greek-ext',
      'hebrew',
      'latin',
      'latin-ext',
      'math',
      'symbols',
      'vietnamese',
    ],
    version: 'v40',
    lastModified: '2024-09-04',
    category: 'sans-serif',
  },
  {
    family: 'Roboto',
    variants: [
      '100',
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
    subsets: [
      'cyrillic',
      'cyrillic-ext',
      'greek',
      'greek-ext',
      'latin',
      'latin-ext',
      'math',
      'symbols',
      'vietnamese',
    ],
    version: 'v47',
    lastModified: '2025-01-08',
    category: 'sans-serif',
  },
  {
    family: 'Montserrat',
    variants: [
      '100',
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
    subsets: ['cyrillic', 'cyrillic-ext', 'latin', 'latin-ext', 'vietnamese'],
    version: 'v29',
    lastModified: '2024-11-07',
    category: 'sans-serif',
  },
  // { value: "'Signika'", label: 'Signika' },
  {
    family: 'EB Garamond',
    variants: [
      'regular',
      '500',
      '600',
      '700',
      '800',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
    ],
    subsets: [
      'cyrillic',
      'cyrillic-ext',
      'greek',
      'greek-ext',
      'latin',
      'latin-ext',
      'vietnamese',
    ],
    version: 'v30',
    lastModified: '2024-09-30',
    category: 'serif',
  },
  {
    family: 'Merriweather',
    variants: [
      '300',
      '300italic',
      'regular',
      'italic',
      '700',
      '700italic',
      '900',
      '900italic',
    ],
    subsets: ['cyrillic', 'cyrillic-ext', 'latin', 'latin-ext', 'vietnamese'],
    version: 'v30',
    lastModified: '2024-09-04',
    category: 'serif',
  },
  {
    family: 'Source Serif 4',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
      '900',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
    subsets: [
      'cyrillic',
      'cyrillic-ext',
      'greek',
      'latin',
      'latin-ext',
      'vietnamese',
    ],
    version: 'v8',
    lastModified: '2024-09-04',
    category: 'serif',
  },
  {
    family: 'Source Code Pro',
    variants: [
      '200',
      '300',
      'regular',
      '500',
      '600',
      '700',
      '800',
      '900',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
    subsets: [
      'cyrillic',
      'cyrillic-ext',
      'greek',
      'greek-ext',
      'latin',
      'latin-ext',
      'vietnamese',
    ],
    version: 'v23',
    lastModified: '2024-09-04',
    category: 'monospace',
  },
]
